export enum PasswordErrorMessage {
  PasswordTooShort = `Hasło musi mieć minimum 10 znaków.`,
  PasswordRequiresNonAlphanumeric = `Hasło musi zawierać co najmniej 1 znak specjalny.`,
  PasswordRequiresDigit = `Hasło musi zawierać co najmniej jedną cyfrę ('0'-'9').`,
  PasswordRequiresLower = `Hasło musi zawierać co najmniej jedną małą literę ('a'-'z').`,
  PasswordRequiresUpper = `Hasło musi zawierać co najmniej jedną wielką literę ('A'-'Z').`,
  PasswordMismatch = `Podane hasło do konta jest nieprawidłowe.`,
  PasswordTheSame = `Podane nowe hasło jest Twoim aktualnym hasłem.`,
  PasswordsNotTheSame = `Podane hasła nie są takie same.`,
  PasswordIsInvalid = `Nowe hasło nie spełnia reguł dotyczących jego złożoności`,
  PasswordResetError = `Podane nowe hasło jest Twoim aktualnym hasłem.`,
}

export enum BackendErrorCode {
  PasswordTooShort = 'PasswordTooShort',
  PasswordRequiresNonAlphanumeric = 'PasswordRequiresNonAlphanumeric',
  PasswordRequiresDigit = 'PasswordRequiresDigit',
  PasswordRequiresUpper = 'PasswordRequiresUpper',
  PasswordRequiresLower = 'PasswordRequiresLower',
  PasswordTheSame = 'PasswordTheSame',
  PasswordMismatch = 'PasswordMismatch',
  PasswordResetError = 'PasswordResetError',
}

export enum FrontendResponseErrorCode {
  PasswordIsInvalid = 'PasswordIsInvalid',
  PasswordsNotTheSame = 'PasswordsNotTheSame',
}

export type ErrorCode = BackendErrorCode | FrontendResponseErrorCode;
